export default function assertString(input) {
  if (typeof input !== 'string') {
    throw new TypeError('Expected a string');
  }
}
